import { Badge } from "../../../ui/badge";

export function ValidationBadge({ isValid }: { isValid: boolean }) {
  if (isValid) {
    return <Badge variant="success">Validated</Badge>;
  }
  return <Badge variant="outline">Not Validated</Badge>;
}
